import { Box, Button, Grid } from '@mui/material'
import dayjs from 'dayjs'
import { FormField, FormFieldCheckbox } from 'global/components/Form'
import React, { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { useLocation } from 'react-router-dom'
import { centroCustoFuncionario_api, funcionario } from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'
import { AdicionarCentroCusto } from 'templates/Cadastro/CentroCusto/atoms/modals/Adicionar'

import { FuncionarioCentroCustoDataGrid } from './Datagrid'

export const CentroCustoForm: React.FC = () => {
    const { pathname } = useLocation()
    const { watch, setError, clearErrors, setValue } = useFormContext()

    const adicionar = pathname.endsWith('adicionar')

    const funcionarioId = useStore(state => state.employeeId)
    const { mutateAsync } = centroCustoFuncionario_api.mutations.useCreate({
        onSuccess: async () => {
            toast.success('Centro de custo adicionado com sucesso')
            await Promise.all([
                centroCustoFuncionario_api.invalidateQueries(),
                funcionario.invalidateQueries(),
            ])
        },
        onError: ({ message }) => {
            toast.error(message)
        },
    })

    const indeterminado = watch('indeterminado')
    const centroCusto = watch('FuncionarioCentroCusto.CentroCusto')
    const dtInicial = watch('FuncionarioCentroCusto.dtInicial')
    const dtFinal = watch('FuncionarioCentroCusto.dtFinal')

    async function handleClick() {
        if (!dtInicial) {
            setError('FuncionarioCentroCusto.dtInicial', {
                type: 'required',
                message: 'Campo obrigatório',
            })
        } else {
            clearErrors('FuncionarioCentroCusto.dtInicial')

            await mutateAsync({
                centroCustoId: centroCusto.id,
                dtInicial: dayjs(dtInicial).toDate(),
                dtFinal: dtFinal ? dayjs(dtFinal).toDate() : null,
                funcionarioId,
            })
        }
    }

    useEffect(() => {
        if (indeterminado) {
            setValue('FuncionarioCentroCusto.dtFinal', undefined)
        }
    }, [indeterminado, setValue])

    return (
        <Box
            component="section"
            id="centro-custo"
            onKeyDownCapture={e => e.stopPropagation()}
            mt={5}
        >
            <Grid container columns={24} spacing={2}>
                <Grid position="relative" item xs={24} mt={-5}>
                    {!adicionar && (
                        <Button
                            disabled={!centroCusto}
                            onClick={handleClick}
                            variant="text"
                            sx={{
                                position: 'absolute',
                                right: 64,
                                top: '25%',
                                zIndex: 1,
                            }}
                        >
                            Inserir
                        </Button>
                    )}
                    <AdicionarCentroCusto autoComplete />
                </Grid>
                <Grid item xs={8}>
                    <FormField
                        name="FuncionarioCentroCusto.dtInicial"
                        label="Data Inicial"
                        type="date"
                        InputLabelProps={{ shrink: true }}
                        required
                    />
                </Grid>
                <Grid item xs={8}>
                    <FormField
                        name="FuncionarioCentroCusto.dtFinal"
                        label="Data Final"
                        type="date"
                        InputLabelProps={{ shrink: true }}
                        disabled={indeterminado}
                    />
                </Grid>
                <Grid item xs={8}>
                    <FormFieldCheckbox
                        name="indeterminado"
                        label="Data Final Indeterminada"
                        defaultChecked={true}
                    />
                </Grid>
                <Grid item xs={24}>
                    <FuncionarioCentroCustoDataGrid />
                </Grid>
            </Grid>
        </Box>
    )
}
